import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';


@Injectable({
  providedIn: 'root'
})
export class UserReferralApiService extends ApiService {
  readonly resourcePath = 'user_referrals';

  update(id: string, data: object) {
    return this.restUpdate(id, data);
  }
}
